import { Navigate } from "react-router";
import { useTenancyAuth } from "@/context/TenancyAuthContext";
export default function TenancyPrivateRoute({ children }: { children: React.ReactNode }) {
  const { tenancyToken } = useTenancyAuth();
  if (!tenancyToken) return <Navigate to="/tenancy/login" replace />;
  return children;
}